import AsideEditor from '@UI/editor/AsideEditor';
import type { EditAsideStaticHtml } from '@nodeTypeConfig/configTypes';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsideStaticHtml: React.FC<{
  config: EditAsideStaticHtml;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const editHref = useEditHref();

  const initialValue = useInitialValue(config.property);

  return (
    <>
      {config.label && <label className="control-label control-label-inline">{config.label}</label>}
      <AsideEditor
        placeholder={''}
        skey={getResourceKey(editHref)}
        initial={initialValue}
        field="html"
        readOnly={readonly}
        plainText={true}
      />
    </>
  );
};

AsideStaticHtml.displayName = 'AsideStaticHtml';

export default AsideStaticHtml;

AsideStaticHtml.propTypes = {
  config: any,
  readonly: any,
};
